import { Component, OnInit } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ThemeService } from 'ng2-charts';

@Component({
  selector: 'app-list-awp-statewise',
  templateUrl: './list-awp-statewise.component.html',
  styleUrls: ['./list-awp-statewise.component.scss']
})
export class ListAwpStatewiseComponent implements OnInit {

  p: number = 1;
  itemsPerPage: number = 10;
  awpsData: any[] | undefined;
  stateCode:any;
  role:any;
  totalawps:any=0;
  constructor(private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.getawpCount();
  }

  awps: any[] = [{ awp_title: "test title", awp_desc: "Test Description", no_of_trainees: "2" }]

  userName: any;
  //this.role = this.authService.get
 
  getawpCount() {
    this.spinnerService.show();
    this.userName = this.authService.getUserName();
    this.role = this.authService.getRole();
    if(this.role=='ADMIN')
    {
    this.stateCode='ALL'
    this.fswService.getawpListCount(this.stateCode)
      .subscribe(res => {
        debugger
        this.awpsData = res;
        this.awpsData.forEach(val =>{
         
          this.totalawps+=val.total;
           
        });
        this.spinnerService.hide();
      });
  }
  else if(this.role=='RO'){
    var regionCode=localStorage.getItem("REGIONCODE");

    this.fswService.getAWPByRegion(regionCode)
      .subscribe(res => {
        debugger
        this.awpsData = res;
        this.spinnerService.hide();
      });

  }
    else
    {
    this.stateCode=this.authService.getState();
    this.fswService.getawpListCount(this.stateCode)
      .subscribe(res => {
        debugger
        this.awpsData = res;
        this.awpsData.forEach(val =>{
         
          this.totalawps+=val.total;
           
        });
        this.spinnerService.hide();
      });
    }
  }

}
